"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var date_fns_1 = require("date-fns");
var react_1 = __importStar(require("react"));
var react_query_1 = require("react-query");
var modal_1 = __importDefault(require("../../../../../plugins/modal"));
var api_1 = require("../../../api");
var callout_1 = require("../../../components/callout");
var inline_loader_1 = __importDefault(require("../../../components/inline_loader"));
var update_next_charge_date_1 = require("../../../mutations/update-next-charge-date");
exports.default = (function (_a) {
    var groupedSubscription = _a.subscription;
    var _b = __read((0, react_1.useState)(false), 2), showModal = _b[0], setModalVisibility = _b[1];
    var queryClient = (0, react_query_1.useQueryClient)();
    var callout = (0, callout_1.useCallout)().callout;
    var _c = (0, react_query_1.useMutation)(function (variables) { return (0, api_1.getSubscriptionAPIClient)().request(update_next_charge_date_1.UPDATE_NEXT_CHARGE_DATE, variables); }, {
        onSuccess: function () {
            queryClient.invalidateQueries('getCustomerSubscriptions');
        },
    }), updateNextShipDate = _c.mutateAsync, isUpdatingNextChargeDate = _c.isLoading, isError = _c.isError;
    var _d = (0, react_1.useMemo)(function () {
        var _a;
        var nextChargeDate = new Date(groupedSubscription.subscription.next_charge_scheduled_at);
        var chargeFrequency = (_a = groupedSubscription.subscription.properties.find(function (_a) {
            var name = _a.name;
            return name === 'charge_interval_frequency';
        })) === null || _a === void 0 ? void 0 : _a.value;
        var shippingFrequency = Number(chargeFrequency);
        return {
            nextDate: (0, date_fns_1.addWeeks)(nextChargeDate, shippingFrequency),
            showSkipButton: window.accountApp.settings.isSkipShipmentEnabled && chargeFrequency && (0, date_fns_1.differenceInWeeks)(nextChargeDate, new Date()) < shippingFrequency,
        };
    }, [groupedSubscription.subscription.next_charge_scheduled_at]), nextDate = _d.nextDate, showSkipButton = _d.showSkipButton;
    if (!showSkipButton)
        return null;
    var skipShipmentDate = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, updateNextShipDate({ nextChargeDate: (0, date_fns_1.format)(nextDate, 'yyyy-MM-dd'), subscriptionId: groupedSubscription.subscription.id })];
                case 1:
                    _a.sent();
                    callout.success('Next Shipment Date has been updated.');
                    setModalVisibility(false);
                    return [2 /*return*/];
            }
        });
    }); };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(modal_1.default, { isOpen: showModal, handleClose: function () { return setModalVisibility(false); }, className: 'padding-4' },
            react_1.default.createElement("h5", { className: 'margin-bottom-4' }, "Skip your next Shipment"),
            !isUpdatingNextChargeDate && (react_1.default.createElement("div", null,
                react_1.default.createElement("p", { className: 'margin-top-4 font-size-14' },
                    react_1.default.createElement("div", { dangerouslySetInnerHTML: { __html: window.accountApp.settings.skipShipmentHtml || '' } }),
                    react_1.default.createElement("b", { className: 'text-wisteria ' }, (0, date_fns_1.format)(nextDate, 'MMM dd, yyyy'))),
                react_1.default.createElement("button", { className: 'button btn-form margin-top-8', onClick: function () { return skipShipmentDate(); }, disabled: isUpdatingNextChargeDate }, window.accountApp.settings.skipShipmentButtonCta))),
            isUpdatingNextChargeDate && (react_1.default.createElement("div", null,
                react_1.default.createElement(inline_loader_1.default, { loadingText: "Updating next order date.", isLoading: true })))),
        react_1.default.createElement("button", { className: 'button btn margin-top-4 hollow', onClick: function () { return setModalVisibility(true); } }, "Skip Shipment")));
});
